module.exports = __webpack_public_path__ + "news-4a753f38/free-cover-3afb766bab04848423d6efdb4f226321.svg";